import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboNivelGenetico`, method: 'GET', body: null, token: token})
}